import React, {createRef, useState} from 'react'

import cn from '../../libs/class-names'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  title?: string
  postfix?: React.ReactNode
  block?: boolean
  maxWidth?: boolean
  size?: 'default' | 's' | 'xs'
  minor?: boolean
  hidePostfix?: boolean
}

const TruncatedLabel = ({
  classNames,
  children,
  title,
  postfix,
  block = false,
  maxWidth = false,
  size = 'default',
  minor = false,
  hidePostfix = false, // hide postfix if content is not truncated
}: Props) => {
  const [isTruncated, setIsTruncated] = useState(false)

  const spanRef = createRef<HTMLSpanElement>()

  React.useEffect(() => {
    if (hidePostfix && spanRef.current) {
      const {current} = spanRef
      setIsTruncated(current.offsetWidth < current.scrollWidth)
    }
  }, [spanRef, hidePostfix])

  return (
    <div
      title={title}
      className={cn('TruncatedLabel', {block, maxWidth, [`size-${size}`]: true, minor}, classNames)}
    >
      <span ref={spanRef} className="TruncatedLabel__content">
        {children}
      </span>
      {postfix && ((hidePostfix && isTruncated) || !hidePostfix) && (
        <span className="TruncatedLabel__postfix">{postfix}</span>
      )}
    </div>
  )
}

export default TruncatedLabel
